var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.322,
    height: 24.322,
    viewBox: "0 0 24.322 24.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-whatsapp",
    "data-name": "Icon awesome-whatsapp",
    d: "M20.68,5.784A12.057,12.057,0,0,0,1.71,20.329L0,26.572l6.39-1.678a12.016,12.016,0,0,0,5.76,1.466h.005A12.169,12.169,0,0,0,24.322,14.308,12.1,12.1,0,0,0,20.68,5.784ZM12.156,24.33a10,10,0,0,1-5.1-1.4l-.364-.217-3.79.994,1.01-3.7-.239-.38a10.037,10.037,0,1,1,18.616-5.326A10.13,10.13,0,0,1,12.156,24.33Zm5.494-7.5c-.3-.152-1.781-.88-2.058-.977s-.478-.152-.679.152-.776.977-.956,1.184-.353.228-.651.076a8.2,8.2,0,0,1-4.1-3.583c-.309-.532.309-.494.885-1.645a.558.558,0,0,0-.027-.527c-.076-.152-.679-1.634-.928-2.237-.244-.586-.494-.5-.679-.516s-.375-.011-.575-.011a1.116,1.116,0,0,0-.8.375,3.384,3.384,0,0,0-1.053,2.514,5.9,5.9,0,0,0,1.227,3.116A13.458,13.458,0,0,0,12.4,19.3c1.911.825,2.66.9,3.616.755a3.085,3.085,0,0,0,2.03-1.433,2.519,2.519,0,0,0,.174-1.433C18.15,17.05,17.949,16.974,17.65,16.827Z",
    transform: "translate(0 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp_icon.7f0f2457fc57485f6be2124c6b4bc80b.svg";
export { ForwardRef as ReactComponent };